import { AxiosError } from "axios";
import customAxios from "config";
import { globalJson } from "global/global_json";

export const getCompanyInfoFun = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/company/configurations/", {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred during fetching company data",
      };
    }
    return { error: "An unknown error occurred." };
  }
};
export const getCompanyID = async (): Promise<any> => {
  try {
    // for testing
    // globalJson.company_id = 24;
    // return { company_id: 24 };

    const response = await customAxios.get("/api/company/get-website-id/");
    globalJson.company_id = response?.data?.company_id;
    return {
      company_id: response?.data?.company_id,
    };
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred during fetching company ID",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

export const getWebInfo = async (): Promise<any> => {
  try {
    const response = await customAxios.get(`api/website/details/`, {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred during fetching web info",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

export const getWebsiteSectionInfo = async (): Promise<any> => {
  try {
    const response = await customAxios.get(`api/website/sections/`, {
      params: {
        company_id: globalJson.company_id,
      },
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred during fetching website section info",
      };
    }
    return { error: "An unknown error occurred." };
  }
};